const whKeyIndicator = {
  dc: 'DC',
  assessMonth: 'AssessMonth',
  assessMonthStart: 'StartMonth',
  assessMonthEnd: 'EndMonth',
  carrierCode: 'CarrierCode',
  serviceProvider: 'ServiceProvider',
  totalShipOrders: 'TotalShipOrders',
  damagedBoxCount: 'DamagedBoxCount',
  totalInventoryBox: 'TotalInventoryBox',
  spotCheckDiffBox: 'SpotCheckDiffBox',
  totalInOrders: 'TotalInOrders',
  delayedInOrders: 'DelayedInOrders',
  repackOrders: 'RepackOrders',
  repackErrorOrders: 'RepackErrorOrders',
  totalShipErrorOrders: 'TotalShipErrorOrders',
  spotCheckTotalBox: 'SpotCheckTotalBox',
  delayedComplaints: 'DelayedComplaints',
  adjustItems: 'AdjustItems',
  createTime: 'CreateTime',
  msg: {}
};
export default whKeyIndicator;



// WEBPACK FOOTER //
// ./src/page/assess/whKeyIndicator/lang/whKeyIndicator.en.js